import React, {Component} from 'react';
import {connect} from 'react-redux';

// Components
import {T} from 'Actions/translate';
import BasicButton from 'Components/common/BasicButton';
import {loadLanguage} from 'Utils/jwtUtil';
import Anchor from 'Components/common/Anchor';
import BaseImageUploader from 'Components/common/BaseImageUploader';
import util from 'Utils/commonUtil';
import {openNotification} from 'Actions/notification';
import Dialog from 'Components/common/DialogImage';
import {
    uploadTagOfAdventProduct,
    uploadReceiveImage,
    previewTagUploadImage,
} from 'Actions/host';

class AdventProductCard extends Component {
    state = {
        chooseImage: null,
        tagUploadDialogOpened: false,
        previewImageDialogOpened: false,
        currentAdventId: 0,
        tagType: 'Y',
        loading: false,
        imageStream: {},
    };

    tagUploadHandle = (id, type) => {
        this.setState({
            currentAdventId: id,
            tagUploadDialogOpened: true,
            tagType: type,
        });
    };

    dialogDidClose = (dialog) =>
        this.state[dialog] && this.setState({[dialog]: false});

    previewImageDialogDidClose = () => {
        if (this.state.previewImageDialogOpened) {
            this.setState({
                previewImageDialogOpened: false,
            });
        }
    };

    chooseImage = (item) =>
        this.refs['inputFile'] && this.refs['inputFile'].click();

    selectedImage = (ev) => {
        if (!ev.target.files && !ev.target.files[0]) return;
        const reader = new FileReader();
        const file = ev.target.files[0];

        reader.onload = (ev) => {
            this.setState({chooseImage: {file, url: ev.target.result}});
        };

        reader.readAsDataURL(file);
    };

    uploadConfirmHandle = () => {
        const {currentAdventId, tagType} = this.state;
        this.setState({
            loading: true,
        });
        if (this.state.chooseImage) {
            this.props
                .uploadReceiveImage({
                    type: 'expired_product',
                    file: this.state.chooseImage.file,
                })
                .then((res) => {
                    let params = {
                        id: currentAdventId,
                        pic: res.url,
                        type: tagType,
                    };
                    this.props
                        .uploadTagOfAdventProduct(params)
                        .then((res) => {
                            if (res) {
                                this.props.adventInventoryDetail();
                                this.setState({
                                    tagUploadDialogOpened: false,
                                    chooseImage: null,
                                    loading: false,
                                });
                                this.props.openNotification(
                                    T('notification_successfully_upload'),
                                    'success',
                                );
                            }
                        })
                        .catch(() => {
                            this.setState({loading: false});
                        });
                })
                .catch(() => {
                    this.setState({loading: false});
                    this.props.openNotification(
                        T('notification_picture_upload_failed'),
                        'danger',
                    );
                });
        } else {
            this.setState({
                loading: false,
            });
            this.props.openNotification(
                T('host_advent_products_upload_tag_is_not_null'),
                'danger',
            );
        }
    };

    previewTagImage = (subAdventProductItem) => {
        this.props
            .previewTagUploadImage(
                {path: subAdventProductItem.abnormalPic},
                'Advent Image',
            )
            .then((res) => {
                if (this.props.previewData) {
                    this.setState(
                        {
                            previewImageDialogOpened: true,
                            imageStream: this.props.previewData,
                        },
                        () => {
                            let img = new Image();
                            img.src = this.props.previewData;
                            img.id = 'adventImage';

                            if (document.getElementById('adventImage')) {
                                document.getElementById('adventImage').remove();
                            }
                            document
                                .getElementById('testImage')
                                .appendChild(img);
                        },
                    );
                }
            })
            .catch((res) => {
                console.log(res);
            });
    };

    isShowYellowBtn = (subAdventProductItem) => {
        let isShowBtn = true;
        if (
            subAdventProductItem.abnormalType === 'Y' &&
            subAdventProductItem.abnormalPic
        ) {
            isShowBtn = false;
        }
        return isShowBtn;
    };

    render() {
        const {
            tagUploadDialogOpened,
            chooseImage,
            loading,
            imageStream,
            previewImageDialogOpened,
        } = this.state;
        const {adventProducts} = this.props;
        let lang = loadLanguage();

        return (
            <div>
                <ul className="advent-product-detail-container parent-advent-product-ul">
                    <li
                        key={this.props.key}
                        className="advent-product-detail-li">
                        <div className="parent-sku-value">
                            {adventProducts.sku}
                        </div>
                        <div className="parent-description-container">
                            <div className="parent-first-column">
                                {/* <div className="parent-second-column-label">{T('host_advent_product_specifications')}</div> */}
                                {T('host_advent_product_specifications')}
                                <span className="parent-second-column-value">
                                    {adventProducts.specifications}
                                </span>
                            </div>
                            <div className="parent-second-column">
                                {T('storeCondition')}:
                                <span className="parent-second-column-value">
                                    {adventProducts.storageCondition}
                                </span>
                            </div>
                        </div>

                        <ul className="advent-product-detail-childen-container childen-advent-product-ul">
                            {adventProducts.items &&
                                adventProducts.items.length > 0 &&
                                adventProducts.items.map(
                                    (
                                        subAdventProductItem,
                                        subAdventProductIndex,
                                    ) => (
                                        <li
                                            className="advent-product-detail-sub-li"
                                            key={subAdventProductIndex}>
                                            <div className="childen-row">
                                                <div className="childen-first-column item-column lot-column">
                                                    {T(
                                                        'host_advent_products_lot',
                                                    )}
                                                    <span className="parent-second-column-value">
                                                        {
                                                            subAdventProductItem.lot
                                                        }
                                                    </span>
                                                </div>

                                                {this.isShowYellowBtn(
                                                    subAdventProductItem,
                                                ) ? (
                                                    <div className="childen-second-column">
                                                        <div
                                                            item
                                                            className={
                                                                subAdventProductItem.abnormalType ===
                                                                'R'
                                                                    ? 'upload-advent-product-btn red-btn'
                                                                    : 'upload-advent-product-btn yellow-btn'
                                                            }
                                                            xs={6}>
                                                            <BasicButton
                                                                onClickOfSingleTap={() =>
                                                                    this.tagUploadHandle(
                                                                        subAdventProductItem.id,
                                                                        subAdventProductItem.abnormalType,
                                                                    )
                                                                }>
                                                                {T(
                                                                    'host_advent_products_upload',
                                                                )}
                                                            </BasicButton>
                                                        </div>
                                                    </div>
                                                ) : null}
                                            </div>
                                            <div className="childen-row">
                                                <div className="childen-first-column">
                                                    {subAdventProductItem.abnormalType ===
                                                    'R'
                                                        ? T(
                                                              'host_advent_products_expired_quantity',
                                                          )
                                                        : T(
                                                              'host_advent_products_advent_quantity',
                                                          )}
                                                    <span className="parent-second-column-value">
                                                        {
                                                            subAdventProductItem.totalInventory
                                                        }
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="childen-row">
                                                <div className="childen-first-column">
                                                    {T(
                                                        'host_advent_products_dnsa',
                                                    )}
                                                    <span className="parent-second-column-value">
                                                        {
                                                            subAdventProductItem.dnsaDate
                                                        }
                                                    </span>
                                                </div>
                                                <div className="childen-second-column">
                                                    {T(
                                                        'host_advent_products_expiration_date',
                                                    )}
                                                    <span className="parent-second-column-value">
                                                        {
                                                            subAdventProductItem.lotExpirationDate
                                                        }
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="childen-row">
                                                {subAdventProductItem.abnormalPic ? (
                                                    <div className="childen-first-column">
                                                        {T(
                                                            'host_advent_products_advent_tag',
                                                        )}
                                                        <span className="parent-second-column-value">
                                                            {
                                                                subAdventProductItem.abnormalUploadTime
                                                            }
                                                        </span>
                                                    </div>
                                                ) : null}
                                                {subAdventProductItem.abnormalPic ? (
                                                    <div className="childen-second-column tag-operation">
                                                        <Anchor
                                                            className="tag-preview"
                                                            scr={imageStream}
                                                            key={
                                                                subAdventProductItem.id
                                                            }
                                                            onClickOfSingleTap={() =>
                                                                this.previewTagImage(
                                                                    subAdventProductItem,
                                                                )
                                                            }>
                                                            {T('order_preview')}
                                                        </Anchor>
                                                        <Anchor
                                                            className="tag-upload"
                                                            onClickOfSingleTap={() =>
                                                                this.tagUploadHandle(
                                                                    subAdventProductItem.id,
                                                                    'Y',
                                                                )
                                                            }>
                                                            {T(
                                                                'shippment_upload_again',
                                                            )}
                                                        </Anchor>
                                                    </div>
                                                ) : null}
                                            </div>
                                        </li>
                                    ),
                                )}
                        </ul>
                    </li>
                </ul>

                <Dialog
                    opened={tagUploadDialogOpened}
                    dialogDidClose={() =>
                        this.dialogDidClose('tagUploadDialogOpened')
                    }
                    options={{bgClickClose: true}}>
                    <div className="upload-image-dialog">
                        <h5 className="upload-method-title text-center">
                            {T('host_advent_products_confirm_upload_tag')}
                        </h5>
                        <p className="tag-upload-dialog-desc text-center">
                            <BaseImageUploader
                                className={util.getClassName({
                                    'upload-method-upload text-center':
                                        true && lang !== 'EN',
                                    'en-upload-method-upload text-center':
                                        true && lang === 'EN',
                                })}
                                onClickOfSingleTap={this.chooseImage}>
                                {chooseImage && chooseImage.url ? (
                                    <img src={chooseImage.url} alt="" />
                                ) : (
                                    <>
                                        <span className="upload-method-upload-icon" />
                                        <span className="upload-method-upload-text">
                                            {T('host_abnormal_upload_here')}
                                        </span>
                                    </>
                                )}
                                <input
                                    ref="inputFile"
                                    type="file"
                                    accept="image/*"
                                    onChange={this.selectedImage}
                                />
                            </BaseImageUploader>
                        </p>
                        <div className="upload-method-actions">
                            <BasicButton
                                type="primary"
                                className="upload-method-submit"
                                loading={loading}
                                onClickOfSingleTap={this.uploadConfirmHandle}>
                                {T('order_confirm')}
                            </BasicButton>
                            <BasicButton
                                className="upload-method-cancel"
                                onClickOfSingleTap={() =>
                                    this.dialogDidClose('tagUploadDialogOpened')
                                }>
                                {T('cancel')}
                            </BasicButton>
                        </div>
                    </div>
                </Dialog>
                <Dialog
                    opened={previewImageDialogOpened}
                    dialogDidClose={this.previewImageDialogDidClose}
                    options={{bgClickClose: true}}>
                    <div className="tag-preview-dialog">
                        <p id="testImage" className="text-center"></p>
                        <div className="tag-preview-btn-container">
                            <BasicButton
                                type="primary"
                                className="cancel-confirm-btn"
                                onClickOfSingleTap={
                                    this.previewImageDialogDidClose
                                }>
                                {T('shopping_cart_close')}
                            </BasicButton>
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {host} = state;
    return {
        previewData: host.previewData,
    };
};

const mapDispatchToProps = {
    uploadTagOfAdventProduct,
    uploadReceiveImage,
    previewTagUploadImage,
    openNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdventProductCard);
